export interface CategoryGroup {
  id: number;
  name: string;
  translationFile?: string;
}

export const GREYHOUNDS_CATEGORY_GROUP_ID = 5;

export const categoryGroups: CategoryGroup[] = [
  { id: 18, name: 'AMERICAN FOOTBALL', translationFile: 'american_football' },
  { id: 11, name: 'ATHLETICS', translationFile: 'athletics' },
  { id: 23, name: 'AUSSIE RULES', translationFile: 'aussie_rules' },
  { id: 32, name: 'BADMINTON', translationFile: 'badminton' },
  { id: 48, name: 'BANDY', translationFile: 'bandy' },
  { id: 46, name: 'BASEBALL', translationFile: 'baseball' },
  { id: 47, name: 'BASKETBALL', translationFile: 'basketball' },
  { id: 28, name: 'BETTYPE', translationFile: 'bettype' },
  { id: 31, name: 'BOWLS', translationFile: 'bowls' },
  { id: 10, name: 'BOXING', translationFile: 'boxing' },
  { id: 76, name: 'CASINO', translationFile: 'casino' },
  { id: 19, name: 'CRICKET', translationFile: 'cricket' },
  { id: 14, name: 'CYCLING', translationFile: 'cycling' },
  { id: 21, name: 'DARTS', translationFile: 'darts' },
  { id: 49, name: 'DUMMY', translationFile: 'dummy' },
  { id: 33, name: 'EQUESTRIAN', translationFile: 'equestrian' },
  { id: 34, name: 'FINANCIAL', translationFile: 'financial' },
  { id: 29, name: 'FLOORBALL', translationFile: 'floorball' },
  { id: 2, name: 'FOOTBALL', translationFile: 'football' },
  { id: 24, name: 'GAELIC SPORTS', translationFile: 'gaelic_sports' },
  { id: 6, name: 'GOLF', translationFile: 'golf' },
  { id: GREYHOUNDS_CATEGORY_GROUP_ID, name: 'GREYHOUNDS', translationFile: 'greyhounds' },
  { id: 35, name: 'HANDBALL', translationFile: 'handball' },
  { id: 74, name: 'HARNESS RACING', translationFile: 'harness_racing' },
  { id: 36, name: 'HOCKEY', translationFile: 'hockey' },
  { id: 3, name: 'HORSE RACING', translationFile: 'horse_racing' },
  { id: 45, name: 'ICE HOCKEY', translationFile: 'ice_hockey' },
  { id: 0, name: 'LABEL', translationFile: 'label' },
  { id: 27, name: 'MENU', translationFile: 'menu' },
  { id: 17, name: 'MOTOR SPORT', translationFile: 'motor_sport' },
  { id: 37, name: 'NETBALL', translationFile: 'netball' },
  { id: 62, name: 'OLYMPICS', translationFile: 'olympics' },
  { id: 26, name: 'OTHER SPORTS', translationFile: 'other_sports' },
  { id: 25, name: 'POKER', translationFile: 'poker' },
  { id: 68, name: 'POLITICS', translationFile: 'politics' },
  { id: 20, name: 'POOL', translationFile: 'pool' },
  { id: 22, name: 'ROWING', translationFile: 'rowing' },
  { id: 30, name: 'RUGBY LEAGUE', translationFile: 'rugby_league' },
  { id: 9, name: 'RUGBY UNION', translationFile: 'rugby_union' },
  { id: 8, name: 'SNOOKER', translationFile: 'snooker' },
  { id: 15, name: 'SPECIALS', translationFile: 'specials' },
  { id: 38, name: 'SWIMMING', translationFile: 'swimming' },
  { id: 39, name: 'TABLE TENNIS', translationFile: 'table_tennis' },
  { id: 7, name: 'TENNIS', translationFile: 'tennis' },
  { id: 40, name: 'TROTTING', translationFile: 'trotting' },
  { id: 71, name: 'TV', translationFile: 'tv' },
  { id: 61, name: 'VIRTUAL FOOTBALL', translationFile: 'virtual_football' },
  { id: 58, name: 'VIRTUAL MOTORSPORT', translationFile: 'virtual_motorsport' },
  { id: 41, name: 'VOLLEYBALL', translationFile: 'volleyball' },
  { id: 42, name: 'WATER POLO', translationFile: 'water_polo' },
  { id: 43, name: 'WINTER SPORTS', translationFile: 'winter_sports' },
  { id: 44, name: 'YACHTING', translationFile: 'yachting' },
];

type GetTranslationFile = (id: number) => string | undefined;

export const getTranslationFile: GetTranslationFile = id =>
  categoryGroups.find(categoryGroup => categoryGroup.id === id)?.translationFile;
